import React from 'react';
import type { MouseEvent, ReactElement, ReactNode } from 'react';

import * as S from '../../styles';

interface StaticPlayerProps {
	closeIcon?: ReactElement;
	children: ReactNode;
	portrait?: boolean;
	onClose?: () => void;
	onClick?: (event: MouseEvent) => void;
	onMouseEnter?: (event: MouseEvent) => void;
	onMouseLeave?: (event: MouseEvent) => void;
}

export function StaticPlayer({
	children,
	closeIcon,
	portrait,
	onClose,
	onClick,
	onMouseEnter,
	onMouseLeave
}: Readonly<StaticPlayerProps>): JSX.Element {
	return (
		<S.VideoContainerWrapper $portrait={portrait}>
			{closeIcon && (
				<S.CloseButton onClick={onClose} data-testid="static-close-button">
					{closeIcon}
				</S.CloseButton>
			)}
			<S.VideoContainer onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
				{children}
			</S.VideoContainer>
		</S.VideoContainerWrapper>
	);
}
